import {createContext, useContext} from 'react';

const context = createContext(false);

export const RealUserModeProvider = context.Provider;
export const useIsRealUserModeEnabled = () => useContext(context);
